var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1378",
    "data-name": "Group 1378",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.434,
    height: 23.007,
    viewBox: "0 0 16.434 23.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1114",
    "data-name": "Rectangle 1114",
    width: 16.434,
    height: 23.007,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1377",
    "data-name": "Group 1377",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25613",
    "data-name": "Path 25613",
    d: "M.786,20.015V15.921a3.286,3.286,0,0,1,2.385-3.16L6.539,11.8l1.642,1.643L9.826,11.8l3.366.962a3.286,3.286,0,0,1,2.384,3.16v4.094a1.642,1.642,0,0,1-1.643,1.643H2.429A1.643,1.643,0,0,1,.786,20.015",
    transform: "translate(0.035 0.528)",
    fill: "#4abcee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25614",
    "data-name": "Path 25614",
    d: "M.786,20.015V15.921a3.286,3.286,0,0,1,2.385-3.16L6.539,11.8l1.642,1.643L9.826,11.8l3.366.962a3.286,3.286,0,0,1,2.384,3.16v4.094a1.642,1.642,0,0,1-1.643,1.643H2.429A1.643,1.643,0,0,1,.786,20.015Z",
    transform: "translate(0.035 0.528)",
    fill: "none",
    stroke: "#323233",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.573
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25615",
    "data-name": "Path 25615",
    d: "M12.149,4.895A4.108,4.108,0,1,1,8.041.786a4.108,4.108,0,0,1,4.108,4.109",
    transform: "translate(0.176 0.035)",
    fill: "#fe9e2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25616",
    "data-name": "Path 25616",
    d: "M12.149,4.895A4.108,4.108,0,1,1,8.041.786,4.108,4.108,0,0,1,12.149,4.895Z",
    transform: "translate(0.176 0.035)",
    fill: "none",
    stroke: "#323233",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.573
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    y1: 3.287,
    transform: "translate(4.108 18.899)",
    fill: "none",
    stroke: "#323233",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.573
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    y2: 3.287,
    transform: "translate(12.325 18.899)",
    fill: "none",
    stroke: "#323233",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.573
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentIcon);
export default __webpack_public_path__ + "static/media/student-icon.8f655221ab3d6519d5e4858d7d75f9a4.svg";
export { ForwardRef as ReactComponent };